import {
  DESKTOP_SIMPLIFIED_SITE_NAVIGATION,
  MOBILE_SIMPLIFIED_SITE_NAVIGATION
} from '@dtx-company/true-common/src/constants/featureFlags'
import { REDESIGNED_NAVIGATION_AND_FLOWLYTICS_LANDING_PAGE_AB_TEST } from '@dtx-company/true-common/src/constants/experiments'
import { useFlowExperiment } from '@dtx-company/inter-app/src/hooks/useFlowExperiment/useFlowExperiment'
import { useFlowFeature } from '@dtx-company/inter-app/src/hooks/useFlowFeature/useFlowFeature'
import { useShowFlowlyticsLandingPage } from './useShowFlowlyticsLandingPage'

interface UseNavV3FeatureFlagsType {
  showV3DesktopNav: boolean
  showV3MobileNav: boolean
  shouldShowAnalyticsLandingPage: boolean
}

export const useNavV3FeatureFlags = (): UseNavV3FeatureFlagsType => {
  const [showV3DesktopNav] = useFlowFeature(DESKTOP_SIMPLIFIED_SITE_NAVIGATION, {
    autoUpdate: true
  })
  const [showV3MobileNav] = useFlowFeature(MOBILE_SIMPLIFIED_SITE_NAVIGATION, { autoUpdate: true })
  const shouldShowAnalyticsLandingPage = useShowFlowlyticsLandingPage()
  const [variant] = useFlowExperiment(REDESIGNED_NAVIGATION_AND_FLOWLYTICS_LANDING_PAGE_AB_TEST, {
    autoUpdate: true
  })
  const showAllFeatures = variant === 'variation_2'
  if (showAllFeatures) {
    return {
      showV3DesktopNav: true,
      showV3MobileNav: true,
      shouldShowAnalyticsLandingPage: true
    }
  } else {
    return {
      showV3DesktopNav,
      showV3MobileNav,
      shouldShowAnalyticsLandingPage
    }
  }
}
